// src/App.js (corrected structure)
import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Footer from "./components/Footer";
import ServicesPage from "./pages/ServicesPage";
import AdminDashboard from "./pages/AdminDashboard";
import { db } from "./Firebase/Config";
import { collection, getDocs } from "firebase/firestore";
import VerificationPage from "./pages/VerificationPage";
import AdminChat from "./pages/AdminChat";
import UserProfile from "./pages/UserProfile";
import ProjectPage from "./pages/ProjectPage";
import EditProfile from "./pages/EditProflie";
import InvoiceForm from "./components/InvoiceForm";
import InteriorDecals from "./pages/InteriorDecals";
import FastFlash from "./pages/FastFlash";
import ResidentialPainting from "./pages/ResidentialPainting";
import CommercialPainting from "./pages/CommercialPainting";
import RentalPaintingFastFlash from "./pages/RentalPaintingFastFlash";
import AirbnbPainting from "./pages/AirbnbPainting";
import InteriorPainting from "./pages/InteriorPainting";
import ExteriorPainting from "./pages/ExteriorPainting";
import HousePainters from "./pages/HousePainters";
import BlogIndex from "./pages/BlogIndex";
import BlogLandlordRepaint from "./pages/BlogLandlordRepaint";
import BlogEstimate from "./pages/BlogEstimate";
import QuotePage from "./pages/QuotePage";
import AboutPage from "./pages/AboutPage";
import Gallery from "./pages/Gallery";

const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const themeMap = {
      "/": "home",
      "/residential-painting": "residential",
      "/commercial-painting": "commercial",
      "/interior-painting": "interior",
      "/exterior-painting": "exterior",
      "/rental-painting-fast-flash": "fast-flash-rentals",
      "/fast-flash-rentals": "fast-flash-rentals",
      "/airbnb-painting": "airbnb",
      "/house-painters": "house-painters",
      "/blog": "blog",
      "/blog/how-often-should-landlords-repaint-rentals-kingwood": "blog",
      "/blog/how-we-build-your-painting-estimate-kingwood": "blog",
      "/interior-decals": "interior-decals",
      "/fast-flash": "fast-flash",
      "/about": "about",
      "/gallery": "gallery",
    };

    const matchKey =
      Object.keys(themeMap).find((key) => path === key || path.startsWith(key + "/")) || "/";
    const theme = themeMap[matchKey] || "home";
    document.documentElement.setAttribute("data-theme", theme);
  }, [location.pathname]);

  useEffect(() => {
    const testConnection = async () => {
      try {
        console.log("Testing Firestore connection...");
        const querySnapshot = await getDocs(collection(db, "estimates"));
        console.log("Connected to Firestore successfully!");
        querySnapshot.forEach((doc) => {
          console.log(`${doc.id} =>`, doc.data());
        });
      } catch (error) {
        console.error("Error connecting to Firestore:", error.message);
        console.error("Full error:", error);
      }
    };
    testConnection();
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/interior-decals" element={<InteriorDecals />} />
          <Route path="/fast-flash" element={<FastFlash />} />
          <Route path="/residential-painting" element={<ResidentialPainting />} />
          <Route path="/commercial-painting" element={<CommercialPainting />} />
          <Route path="/rental-painting-fast-flash" element={<RentalPaintingFastFlash />} />
          <Route path="/airbnb-painting" element={<AirbnbPainting />} />
          <Route path="/interior-painting" element={<InteriorPainting />} />
          <Route path="/exterior-painting" element={<ExteriorPainting />} />
          <Route path="/house-painters" element={<HousePainters />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route
            path="/blog/how-often-should-landlords-repaint-rentals-kingwood"
            element={<BlogLandlordRepaint />}
          />
          <Route
            path="/blog/how-we-build-your-painting-estimate-kingwood"
            element={<BlogEstimate />}
          />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/estimate" element={<ServicesPage />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/chat/:uid" element={<AdminChat />} />
          <Route path="/profile/:uid" element={<UserProfile />} />
          <Route path="/project/:projectId" element={<ProjectPage />} />
          <Route path="/invoice-form" element={<InvoiceForm />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
